import { render } from "./MapTrainer.vue?vue&type=template&id=394c12d4&ts=true"
import script from "./MapTrainer.vue?vue&type=script&lang=ts"
export * from "./MapTrainer.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__